export default async function openOldTask(taskId) {
    // this.props.blockHandle();

    await app.modules.use('app.tasks.quickView');
    app.tasks.quickView(+taskId, () => {
        loader.killReact('reactliveel');
    });
}
